document.addEventListener('DOMContentLoaded', () => {
  const searchInputCollections = document.querySelectorAll('.search-input-float')
  if (searchInputCollections.length === 0) {
    return
  }

  for (let i = 0; i < searchInputCollections.length; i++) {
    const searchInputContainer = searchInputCollections[i]

    const searchInput = searchInputContainer.querySelector('.search-input-float__input')
    const searchInputButton = searchInputContainer.querySelector('.search-input-float__button')
    const searchInputButtonClose = searchInputContainer.querySelector('.search-input-float__close-button')

    searchInputButton.addEventListener('click', e => {
      searchInputContainer.style.width = '256px'
      searchInput.classList.remove('hidden')
      searchInput.classList.add('visible')
      searchInputButton.classList.add('pointer-events-none')
    }
    )

    searchInput.addEventListener('input', e => {
      if (e.target.value.length > 0) {
        searchInputButtonClose.classList.remove('hidden')
      } else {
        searchInputButtonClose.classList.add('hidden')
      }
    })

    searchInputButtonClose.addEventListener('click', e => {
      searchInput.value = ''
      searchInputButtonClose.classList.add('hidden')
    }
    )

  }
})


